import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import customer from './modules/customer';
import flow from './modules/flow';
import dashboard from './modules/dashboard';
import favorite from './modules/favorite';
import alert from './modules/alert';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    auth,
    flow,
    dashboard,
    customer,
    favorite,
    alert,
  },
  strict: debug,
});
